import { render, staticRenderFns } from "./PlayerFetched.vue?vue&type=template&id=718e846e&"
import script from "./PlayerFetched.vue?vue&type=script&lang=js&"
export * from "./PlayerFetched.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports